import { formatPrice } from '@schuelerhilfe/shared/src/pricing/priceZones';
import type { CityPriceEntry } from '@/lib/render/RenderContext';

/**
 * Resolves a price from the city-level price map by exact `placeholder` match.
 * The City Page counterpart to `resolvePrice` — zone selection and aggregation
 * already happened backend-side, so this is a lookup plus formatting.
 *
 * Each entry carries its own currency, so CHF cities format correctly.
 * Returns a formatted price string (e.g. "9,35 €") or null when absent —
 * including when there is no `pricePlaceholder` to look up, which since
 * SH-415 means the column carries a literal `fixedPrice` instead.
 */
export function resolveCityPrice(
  prices: Record<string, CityPriceEntry> | undefined,
  pricePlaceholder: string | undefined,
): string | null {
  const entry = pricePlaceholder ? prices?.[pricePlaceholder] : undefined;
  return entry ? formatPrice(entry.price, entry.currency) : null;
}
